import React from "react";
import BaseComponent from "../BaseComponent.js";
import styled from "styled-components";
import nota from "../Global/nota.guidelines.json";

import NanoFlex from "../Global/NanoFlex.js";
import Type from "../Global/Typography.js";

import { ReactComponent as Check } from "../Global/Icons/check.svg";
import { ReactComponent as NotaSelection } from "../Global/Icons/notaSelection.svg";

const multiple = nota.global.multiple;

const StyledNotaSelectionSelect = styled.div`
  margin: ${multiple / 2 + "px"} 0;
  .NotaSelectionSelectWrapper {
    -webkit-user-select: none; /* Chrome all / Safari all */
    -moz-user-select: none; /* Firefox all */
    -ms-user-select: none; /* IE 10+ */
    user-select: none; /* Likely future */
    .optionWrapper {
      background-color: ${nota.color.neutral.NeuFour};
      width: 100%;
      cursor: pointer;
      margin-bottom: ${multiple / 2 + "px"};
      padding: 6px;

      .checkBoxWrapper {
        height: 100%;
        width: 50px;
        padding-right: 5px;
        svg {
          width: 13px;
          height: auto;
          path {
            fill: ${nota.color.neutral.NeuThree};
          }
        }
      }
      p {
        font-size: 12px;
      }

      .iconWrapper {
        svg {
          width: 40px;
          height: 26px;
          path {
            fill: ${nota.color.neutral.NeuOne};
          }
        }
      }

      &:hover {
        opacity: 0.7;
      }
    }
    .selectedOption {
      background-color: ${nota.color.main.default};
      .checkBoxWrapper {
        svg {
          path {
            fill: ${nota.color.neutral.white};
          }
        }
      }
      p {
        color: ${nota.color.neutral.white};
      }
      .iconWrapper {
        svg {
          path {
            fill: ${nota.color.neutral.white};
          }
        }
      }
    }
  }
`;

class NotaSelectionSelect extends BaseComponent {
  constructor(props) {
    super(props);

    this.state = {
      selected: this.props.selected,
    };
  }

  componentDidMount() {
    super.componentDidMount();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.selected !== this.state.selected && this.props.onChangeSelection) {
      this.props.onChangeSelection({ selected: this.state.selected });
    }

    if (prevProps.selected !== this.props.selected || this.props.forceSelection) {
      this.setState({ selected: this.props.selected });
    }
  }

  componentWillUnmount() {
    super.componentWillUnmount();
  }

  onClick = () => {
    this.setState({ selected: !this.state.selected });
  };

  render() {
    return (
      <StyledNotaSelectionSelect>
        <NanoFlex className="NotaSelectionSelectWrapper" flexDirection="column" justifyContent="flex-start" alignItems="flex-start">
          <NanoFlex className={`optionWrapper ${this.state.selected ? "selectedOption" : ""}`} onClick={this.onClick}>
            <NanoFlex className="checkBoxWrapper">
              <Check />
            </NanoFlex>
            {/* <NanoFlex className="iconWrapper">
              <NotaSelection />
            </NanoFlex> */}
            <Type.p>{this.translation.advancedSearch.notaSelection.subTitle}</Type.p>
          </NanoFlex>
        </NanoFlex>
      </StyledNotaSelectionSelect>
    );
  }
}

// Set default props
NotaSelectionSelect.defaultProps = {};

export default NotaSelectionSelect;

// --- // Documentation // --- //
/*
import NotaSelectionSelect from './../Nano/NotaSelectionSelect.js';

<NotaSelectionSelect />
*/
